import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useEnableSetFeatures } from '#src/hooks/commonGame/useEnableSetFeatures.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useAvailableRarities } from '#src/hooks/my-cards/useAvailableRarities.tsx';
import { useFeatureFlags } from '#src/hooks/useFeatureFlags.tsx';
import { useLifecycle } from '#src/hooks/useLifecycle.ts';
import { COMMON_GAME_SET } from '#src/set/index.ts';

export const useFilteredShardsChests = () => {
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const seriesNav = useSeriesNav();
  const enableSetFeatures = useEnableSetFeatures();
  const availableRarities = useAvailableRarities();
  const {
    flags: { enableNavToggleProSet = false },
  } = useFeatureFlags();
  const { cardShardsChests } = currentUser || {};

  return cardShardsChests?.filter(shard => {
    if (enableNavToggleProSet) {
      return availableRarities.includes(shard.rarity);
    }
    if (shard.rarity === Rarity.common) {
      return !lifecycle?.hideCommonFeatures && enableSetFeatures;
    }
    if (seriesNav) {
      return shard.cardSet?.slug === COMMON_GAME_SET.cardSet.activeSlug;
    }
    return true;
  });
};
